import { render, staticRenderFns } from "./projectOrder.vue?vue&type=template&id=27a1592a&scoped=true"
import script from "./projectOrder.vue?vue&type=script&lang=js"
export * from "./projectOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a1592a",
  null
  
)

export default component.exports